var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.779,
    height: 23.599,
    viewBox: "0 0 25.779 23.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_icon-icons.com_73532",
    transform: "translate(0.001 -46.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23826",
    "data-name": "Grupo 23826",
    transform: "translate(-0.001 46.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15545",
    "data-name": "Trazado 15545",
    d: "M74.908,120.939l-9.194,8.719a.285.285,0,0,1-.008.055.286.286,0,0,0-.008.055V138.6a1.22,1.22,0,0,0,.3.828.926.926,0,0,0,.719.35h6.14v-7.063h4.094v7.063h6.14a.925.925,0,0,0,.719-.35,1.219,1.219,0,0,0,.3-.828v-8.829a.293.293,0,0,0-.016-.11Z",
    transform: "translate(-62.019 -116.175)",
    fill: "#4588c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15546",
    "data-name": "Trazado 15546",
    d: "M25.6,58.49l-3.5-3.348v-7.5a.621.621,0,0,0-.144-.423.464.464,0,0,0-.368-.165h-3.07a.466.466,0,0,0-.368.165.622.622,0,0,0-.144.423v3.587l-3.9-3.752a1.783,1.783,0,0,0-2.43,0L.177,58.49a.564.564,0,0,0-.176.4.659.659,0,0,0,.112.432L1.1,60.679a.527.527,0,0,0,.336.2.54.54,0,0,0,.384-.129L12.889,50.139,23.954,60.752a.453.453,0,0,0,.336.128h.048a.528.528,0,0,0,.336-.2l.991-1.361a.659.659,0,0,0,.112-.433A.565.565,0,0,0,25.6,58.49Z",
    transform: "translate(0.001 -46.994)",
    fill: "#4588c4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoHome);
export default __webpack_public_path__ + "static/media/icono-home.4d9e58555cce6fc05e5d68b8ee66fc39.svg";
export { ForwardRef as ReactComponent };